import { FileClientT, FileCollectionItemT, FileItemInCollectionT, ImageCollectionItemT } from 'bovaljaren-models';
import { useObserver } from 'mobx-react-lite';
import React, { ReactElement, useContext, useEffect, useMemo, useState } from 'react';
import { AppContext } from '../../../state/app.state';
import SunstudyTimeline, { timeFilenameToTimeString } from './SunStudyTimeline';

type SunStudyContainerProps={
    setRatio?:(value: number) => void;
};


const SunStudyContainer: React.FC<SunStudyContainerProps> = ({ setRatio }): ReactElement => {
    const { state, presentationState } = useContext(AppContext);

    const sortedFiles = useMemo((): FileItemInCollectionT[] | undefined => {
        const fileCollection = presentationState?.showSunStudyModal;

        return fileCollection?.files.slice().sort((a, b) => timeFilenameToTimeString(a.filename) > timeFilenameToTimeString(b.filename) ? 1 : -1) || undefined;

    }, [presentationState?.showSunStudyModal]);


    const [selectedItem, setSelectedItem] = useState<FileItemInCollectionT | undefined>(sortedFiles?.find((d, i) => i === 0 ? true : false) || undefined);
    const [isPlaying, setIsPlaying] = useState(false);

    const onClick = (value: FileItemInCollectionT): void => {
        if (isPlaying) return;

        setSelectedItem(value);
    };

    const getVideoDimensionsOf = (url: string): Promise<{ height: number, width: number}> => {

        return new Promise(resolve => {
            // create the video element
            const video = document.createElement('video');

            // place a listener on it
            video.addEventListener('loadedmetadata', function () {
                // retrieve dimensions
                const height = this.videoHeight;
                const width = this.videoWidth;

                // send back result
                resolve({ height, width });
            }, false);

            // start download meta-datas
            video.src = url;
        });
    };


    useEffect(() => {
        (state?.currentView?.solarStudy?.files[0]?.url?.original && getVideoDimensionsOf(state?.currentView?.solarStudy?.files[0]?.url?.original).then(result => {
            setRatio && setRatio(result.width / result.height);
        })
        );
    }, [setRatio, state?.currentView?.solarStudy?.files]);

    const playIndexDelayed = (index: number) => {
        if (!sortedFiles) return;

        setTimeout(() => {
            setSelectedItem(sortedFiles[index]);

            if (index < sortedFiles.length - 1) {
                playIndexDelayed(index + 1);
            }
            else {
                setIsPlaying(false);
            }
        }, 750);
    };
    const play = () => {
        if (!sortedFiles) return;

        if (isPlaying) return;

        setIsPlaying(true);
        setSelectedItem(sortedFiles[0]);
        playIndexDelayed(1);
    };

    return useObserver(() => (
        <>{sortedFiles && selectedItem && <>
            <div style={{ width: '100%' }}>
                <img style={{ width: '100%' }} src={sortedFiles?.find(i => i.id === selectedItem.id)?.url?.original} alt='sunstudy'/>
            </div>
            <SunstudyTimeline items={sortedFiles} onClick={onClick} selectedItem={selectedItem} play={play}/></>}
        </>));
};


export default SunStudyContainer;